export default {
	init() {
		// JavaScript to be fired on all pages
		$('.scrolldown').click(function() {
			$('html, body').animate(
				{
					scrollTop: $($(this).attr('href')).offset().top,
				},
				400
			);
			return false;
		});
		$(document).on('click', '[data-toggle="lightbox"]', function(event) {
			event.preventDefault();
			$(this).ekkoLightbox({
				alwaysShowClose: true,
			});
		});
		$('#school .slider-school .slider-inner').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			fade: false,
			draggable: false,
			asNavFor: '#school .slider-nav .slider-inner',
		});
		$('#school .slider-nav .slider-inner').slick({
			slidesToShow: 2,
			slidesToScroll: 1,
			asNavFor: '#school .slider-school .slider-inner',
			infinite: true,
			focusOnSelect: true,
			appendArrows: '#school .slider-nav .slider-control',
		});
		$('.slider-testimonial .slider-inner').slick({
			slidesToScroll: 1,
			centerMode: true,
			variableWidth: true,
			swipeToSlide: true,
			infinite: true,
			appendArrows: '.slider-testimonial .slider-control',
			responsive: [
				{
					breakpoint: 576,
					settings: {
						centerMode: false,
						variableWidth: false,
						adaptiveHeight: true,
					},
				},
			],
		});
		$('.slider-agenda .slider-inner').slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			swipeToSlide: true,
			infinite: false,
			appendArrows: '.slider-agenda .slider-control',
			responsive: [
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
						adaptiveHeight: true,
					},
				},
			],
		});
		$('.slider-school-related .slider-inner').slick({
			slidesToScroll: 1,
			centerMode: true,
			variableWidth: true,
			swipeToSlide: true,
			appendArrows: '.slider-school-related .slider-control',
			responsive: [
				{
					breakpoint: 576,
					settings: {
						centerMode: false,
						variableWidth: false,
					},
				},
			],
		});
		$('#project-service-video .slider-project-service-video').on('beforeChange', function() {
			$('iframe').each(function() {
				$(this)[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
			});
		});
		$('#project-service-video .slider-project-service-video').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			fade: false,
			draggable: false,
			asNavFor: '#project-service-video .slider-nav .slider-inner',
		});
		$('#project-service-video .slider-nav .slider-inner').slick({
			slidesToShow: 2,
			slidesToScroll: 1,
			swipeToSlide: true,
			asNavFor: '#project-service-video .slider-project-service-video',
			infinite: true,
			focusOnSelect: true,
			appendArrows: '#project-service-video .slider-nav .slider-control',
		});
		$('.slider-project-service-gallery .slider-inner').slick({
			slidesToScroll: 1,
			centerMode: true,
			variableWidth: true,
			swipeToSlide: true,
			appendArrows: '.slider-project-service-gallery .slider-control',
			responsive: [
				{
					breakpoint: 576,
					settings: {
						centerMode: false,
						variableWidth: false,
					},
				},
			],
		});
		$('.slider-european-project .slider-inner').slick({
			slidesToScroll: 1,
			centerMode: false,
			variableWidth: true,
			swipeToSlide: true,
			appendArrows: '.slider-european-project .slider-control',
			responsive: [
				{
					breakpoint: 576,
					settings: {
						centerMode: false,
						variableWidth: false,
						adaptiveHeight: true,
					},
				},
			],
		});
		$('.slider-buenas-practicas .slider-inner').slick({
			slidesToScroll: 1,
			centerMode: false,
			variableWidth: true,
			swipeToSlide: true,
			appendArrows: '.slider-buenas-practicas .slider-control',
			responsive: [
				{
					breakpoint: 576,
					settings: {
						centerMode: false,
						variableWidth: false,
						adaptiveHeight: true,
					},
				},
			],
		});
		$('.tab-1').on('click', function() {
			$('.tab-1').addClass('active').siblings().removeClass('active');
			$('.tab-content-1').addClass('active').siblings().removeClass('active');
		});
		$('.tab-2').on('click', function() {
			$('.tab-2').addClass('active').siblings().removeClass('active');
			$('.tab-content-2').addClass('active').siblings().removeClass('active');
		});
		$('.tab-3').on('click', function() {
			$('.tab-3').addClass('active').siblings().removeClass('active');
			$('.tab-content-3').addClass('active').siblings().removeClass('active');
		});
		var randoNumo = function(value) {
			return Math.floor(Math.random() * value);
		};
		var list = $('.school-tag-wrap a');
		(function go() {
			list.eq(randoNumo(list.length)).addClass('flick');
			setTimeout(function() {
				go();
			}, 100);
		})();
		var heights = $(".about_text").map(function ()
		{
			return $(this).outerHeight();
		}).get();

		var maxHeight = Math.max.apply(null, heights);
		$( ".about_image" ).each(function() {
			$( this ).height(maxHeight);
		});
		$( window ).resize(function() {
			var heights = $(".about_text").map(function ()
			{
				return $(this).outerHeight();
			}).get();

			var maxHeight = Math.max.apply(null, heights);
			$( ".about_image" ).each(function() {
				$( this ).height(maxHeight);
			});
		});
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js